import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import {
  Layout,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingMindsetTemplate/Layout/Layout';

const OnboardingInvestmentProfileInvestingMindsetTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Layout}
    />
  );
};

OnboardingInvestmentProfileInvestingMindsetTemplate.defaultProps = {
};

OnboardingInvestmentProfileInvestingMindsetTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OnboardingInvestmentProfileInvestingMindsetTemplate };
